import { useState } from "react"
import { useEffect } from "react"
import { tabActivity } from "."

export function useTabActivity() {
    const [isActive, setIsActive] = useState(tabActivity.isActive)
    useEffect(() => {
        tabActivity.listen((bl:boolean)=>{
            setIsActive(bl)
        })
    }, [])
    return isActive
}
